import router from '@config/router';
import dictionary from '@dictionaries/dictionary';
import mixin from '@mixins/mixin';
import store from '@store/index';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import AsyncComputed from 'vue-async-computed';
import VueAxios from 'vue-axios';

import InvestmentBanner from '@components/Banners/Investment/InvestmentBanner.vue';
import AppHeader from '@components/Header/Header.vue';

Vue.use(AsyncComputed);
Vue.use(VueAxios, axios);
Vue.use(VeeValidate, {
    inject: false,
    dictionary,
});
Vue.mixin(mixin);

const vm = new Vue({
    el: '#app',
    components: {
        AppHeader,
        InvestmentBanner,
    },
    router,
    store,
});

export default vm;
